(function($) {
  'use strict';

  if (typeof jcms.emailSignUpSettings != 'undefined') {
    var emailSignUp = {
      settings: {},

      $modal: null,

      bindFormulate: function($form, successCallback) {
        $form = $form || $('#email-form');

        $form.formulate({
          id: $form.attr('id'),
          require: 'FirstName, LastName, Email{email}',
          errorClass: 'error',
          errorParent: true,
          showOnSubmit: '[data-js-hook="email-signup-confirm"]',
          inlineMsg: true,
          inlineMsgClass: 'form__inline-error',
          fireOnSubmit: function(data, form) {
            $('.form__message', $(form)).remove();
          },
          fireOnSuccess: function(data, form) {
            if (typeof JonahTracking != 'undefined') {
              JonahTracking.event.formSubmit($(form).attr('id'));
            }
            if (successCallback) {
              successCallback();
            }
          },
          fireOnError: function(data, form) {
            if (data !== false) {
              var response;
              try {
                response = JSON.parse(data);
                response = response.message;
              } catch(e) {
                response = data;
              }
              var $message = '<p class="form__message background-error">' + response + '</p>';
              $(form).prepend($message);
            }
            if ($('.error :input', $(form)).length) {
              $('.error :input', $(form))[0].focus();
            }
          }
        });
      },

      modal: function() {
        var self = this;
        var matchUrl = this.settings.modal_url_target.replace(/^\/|\/$/g, '').split('/').join('\\/');

        if ($('[href*="'+this.settings.modal_url_target+'"]').length && this.settings.modal_enabled && !window.location.pathname.match(matchUrl)) {
          $('[href*="'+this.settings.modal_url_target+'"]').click(function(e){
            e.preventDefault();

            if (!self.$modal) {
              $.get($(this).attr('href'), function(responseHtml){
                self.$modal = $('<div class="form-modal">' +
                  '<div class="form-modal__content">' +
                    '<a data-js-hook="close-form-modal" class="form-modal__close" href="">&times;</a>' +
                    '<div class="form-modal__body">'+responseHtml+'</div>' +
                  '</div>' +
                '</div>').hide();

                $('body').append(self.$modal);
                self.$modal.fadeIn();

                self.$modal.find('[data-js-hook="close-form-modal"]').click(function(e){
                  e.preventDefault();
                  self.$modal.fadeOut();
                });

                self.$modal.click(function(e){
                  if ($(e.target).parent().is('body')) {
                    self.$modal.fadeOut();
                  }
                });

                $(document).keyup(function(e) {
                  if (e.key === "Escape") {
                    self.$modal.fadeOut();
                  }
                });

                self.bindFormulate(self.$modal.find('form'), function(){
                  var start = 1;
                  var end = self.settings.modal_timeout / 1000;
                  var display = end;

                  var countdown = setInterval(function(){
                    if (start <= end) {
                      -- display;
                      $('#email-sign-up-confirm-countdown-number').text(display);
                      ++start;
                    } else {
                      clearInterval(countdown);
                      $('#email-sign-up-confirm-countdown').hide();
                    }
                  }, 1000);

                  setTimeout(function(){
                    self.$modal.fadeOut();
                  }, self.settings.modal_timeout);
                });

                self.$modal.find('[data-infield-label]').inFieldLabels();

                if (typeof recaptas == 'function') {
                  recaptchas();
                }

              });
            } else {
              self.$modal.fadeIn();
            }
          });

        }
      },

      init: function() {
        this.settings = jcms.emailSignUpSettings;
        this.bindFormulate();

        if (this.settings.modal_enabled) {
          this.modal();
        }
      }
    };

    $(function(){
      emailSignUp.init();
    });
  }
})(jQuery);
